angular.module('unergie.main')
.filter('readingMotivation', (BoFeaturesService) =>
    function (val) {
        switch (val) {
            case 'FACTU':
            case 'FACTU_INTER': return 'Facturation'
            case 'CYCL':
            case 'CYCLIQUE': return 'Relève périodique'
            case 'RES': return 'Résiliation'
            case 'SELF': return 'Auto-relève'
            case 'MES': return 'Mise en service'
            case 'CFNE':
            case 'CFN':
            case 'CFNS': return 'Changement de fournisseur'
            case 'MAJSCP':
            case 'MCT':
            case 'MCF': return 'Modification contractuelle'
            case 'CMAT': return 'Changement de compteur'
            case 'EVENEMENT':
            case 'AUTRE': return 'Divers'
            case 'RECT':
            case 'REDRESS':
            case 'REDRESS-X':
            case 'FACT-REDRESS': return 'Correction de relèves'
            case 'SUSALIM': return `Suspension d'alimentation`
            case 'FIAB': return 'Estimé basé sur une relève réelle'
            case 'ANNULATION':
            case 'FIX': return 'Correction'
            default: return 'Autres motifs'
        }
    }
)
